import { useDispatch, useSelector } from "react-redux";
import Table from "../../shared/Table";
import { useAuth } from "../../hooks/useAuth";
import { dashJobsUpdated } from "../../redux/reducers/dashboard";
import { updateJob } from "../../redux/reducers/jobs/jobSlice";
import { COLUMN_DEFINITIONS } from "./table.config";
import { Card } from "../../shared";

const NewestJobs = ({ status, jobs, title, footerLink }) => {
  const dispatch = useDispatch();
  const { user } = useAuth();

  async function handleUpdate(e, setLoading) {
    const updateData = {
      parentId: user.parentCompany,
      jobId: e.row.original._id,
      data: e.data,
    };

    const res = await dispatch(updateJob(updateData)).unwrap();

    if (res.status === "success") {
      dispatch(dashJobsUpdated(res.data));

      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  }

  return (
    <Card className="h-full !p-2">
      <span className="text-xs md:text-sm uppercase text-gray-500 font-bold ">
        {title}
      </span>
      <Table
        wrapperClasses="mt-3 !h-auto"
        hideHeader
        pageSize={8}
        id="jobs"
        title={title}
        hideCheckbox
        loading={status === "loading"}
        columns={COLUMN_DEFINITIONS}
        data={jobs}
        showFooter
        footerLink={footerLink}
        updateData={handleUpdate}
        tableOuterWrapStyle={{ minHeight: "20em" }}
      />
    </Card>
  );
};

export default NewestJobs;
